import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-97596dc6")

_pushScopeId("data-v-97596dc6")
const _hoisted_1 = { class: "flex flex-row items-center justify-between w-full py-4" }
const _hoisted_2 = { class: "flex flex-row items-center w-full" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_DownloadWithDateRange = _resolveComponent("DownloadWithDateRange")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Search, {
        id: "pickup-dashboard-search",
        placeholder: _ctx.$t('pickupDashboard.searchPlaceholder'),
        class: "w-full lg:w-100 h-9",
        timeout: 300,
        minChar: 0,
        isIconLeft: true,
        isIconClearRight: true,
        value: _ctx.search,
        onClear: () => _ctx.onSearch(''),
        onEnter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch($event.target.value)))
      }, null, 8, ["placeholder", "value", "onClear"]),
      _createVNode(_component_DateRangePicker, {
        modelValue: _ctx.dateRangeModel,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dateRangeModel = $event)),
        class: "w-full lg:w-80 mr-4",
        "max-range": 31,
        "max-date": new Date(),
        onApply: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('apply-date'))),
        onReset: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('reset-date'))),
        placeholder: _ctx.$t('pickupDashboard.allTime')
      }, null, 8, ["modelValue", "max-date", "placeholder"]),
      (_ctx.showShipmentType)
        ? (_openBlock(), _createBlock(_component_MultipleSelectSearch, {
            key: 0,
            class: "w-full lg:w-80 mr-4",
            placeholder: _ctx.$t('pickupDashboard.shipmentType'),
            options: _ctx.shipmentTypes,
            modelValue: _ctx.shipmentType,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.shipmentType = $event)),
            keyName: "name",
            keyValue: "value",
            showSelected: false,
            isSearchReadonly: "",
            showSelectedInInput: "",
            onChange: _ctx.onSelectShipmentType
          }, null, 8, ["placeholder", "options", "modelValue", "onChange"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showDownloadButton)
      ? (_openBlock(), _createBlock(_component_DownloadWithDateRange, {
          key: 0,
          buttonText: _ctx.resolvedDownloadButtonText,
          disabled: _ctx.disableDownloadButton,
          onDownload: _ctx.onDownload
        }, null, 8, ["buttonText", "disabled", "onDownload"]))
      : _createCommentVNode("", true)
  ]))
})